export const ClassNameMap = {
    'selected-range': '#fed200',
    'selected-range-yellow': '#fed200',
    'selected-range-pink': '#fc9399',
    'selected-range-rose': '#de017e',
    'selected-range-blue': '#00c3ed',
    'selected-range-green': '#84cd01',
    'selected-range-purple': '#9f61fe',
    'selected-block': '#fed200',
    'selected-block-yellow': '#fed200',
    'selected-block-pink': '#fc9399',
    'selected-block-rose': '#de017e',
    'selected-block-blue': '#00c3ed',
    'selected-block-green': '#84cd01',
    'selected-block-purple': '#9f61fe',
}

export const BlockTypeMap = {
    video: '视频',
    audio: '音频',
    iframe: '网页',
    interaction: '互动',
}